import { useState } from 'react'
import PropTypes from 'prop-types'

// Internal component
import Svg from '../Svg/Svg'
import DetailBlock from '../DetailBlock/DetailBlock'
import LazyImage from '../LazyImage/LazyImage'
import Caption from '../Caption/Caption'

const Foldout = (props) => {
  const { foldoutItem, modifiers } = props
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  // State Classes
  const openClass = 'is-open'

  const createFoldoutItem = (title, text, image, caption, index) => {
    const [toggleState, setToggleState] = useState(false)

    return (
      text && (
        <div className={`Foldout-item${toggleState ? ` ${openClass}` : ''}`} key={`Foldout-item--${index}`}>
          <div className="Foldout-container">
            <div className="Foldout-toggle" onClick={() => setToggleState(!toggleState)}>
              <h2 className="Foldout-title">{title}</h2>
              {toggleState ? (
                <Svg modifiers={['Foldout-icon']} id="icon-chevron-up" />
              ) : (
                <Svg modifiers={['Foldout-icon']} id="icon-chevron-down" />
              )}
            </div>
            <div className="Foldout-content">
              <DetailBlock content={text} />
              {image && image.length > 0 && (
                <div className="Foldout-imageWrap">
                  <div className="Foldout-image">
                    <LazyImage {...image[0]} />
                  </div>
                  {caption && <Caption iconId="icon-image" html={caption} modifiers={['Caption--foldout']} />}
                </div>
              )}
            </div>
          </div>
        </div>
      )
    )
  }

  return (
    <div className={`Foldout${modifierClasses}`}>
      {foldoutItem &&
        foldoutItem.map((item, index) => {
          return createFoldoutItem(item.title, item.text, item.image, item.caption, index)
        })}
    </div>
  )
}

Foldout.propTypes = {
  foldoutItem: PropTypes.array.isRequired,
  modifiers: PropTypes.array
}

export default Foldout
